<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="synopsis">
<h1>Synopsis</h1>
<p><em>Robin Rainbow</em> is a contemporary work of magic realism written for young adults. Set mainly in the Outer Hebrides, the narrative arc follows the exploits of Robin at home, school and when on his quest, in realms beyond the physical.</p>
<p>Mystery surrounds his birth and when given a Superman suit, he acquires ´strange powers´. At primary school, his questions unsettle his teachers but thrill his peers, especially Conchita from Peru, who knows the secrets of herbs and plants. Both are neighbours to the McBride children who live on property that sits on sacred ley-lines.</p>
<p>The discovery of a casket with a map and riddle sends Robin and his friends on a quest that leads to a series of adventures in which Good versus Evil.</p>
<p>The novel charts their ‘progress’ via dramatic turning-points:</p>
<ol style="list-style-type: decimal">
<li><p><em>Their meeting with HEBS (Highly Evolved Beings)</em></p></li>
<li><p><em>Their capture.</em></p></li>
<li><p><em>Their bid for freedom.</em></p></li>
<li><p><em>Recapture.</em></p></li>
<li><p><em>Sentence to death</em> <em>unless</em>…?</p></li>
<li><p><em>Their last-minute rescue.</em></p></li>
<li><p><em>The resolution and their return to so-called ‘normality’.</em></p></li>
</ol>
<p>Throughout all is the charismatic figure of Grandma Fairchild who tells the children ‘unheard of’ stories and encourages them to tell to the others their own story and asks them to consider what it is that makes for a ‘good tale’.</p>
<p>When the Robin 5 engage in the war against Evil in otherworldly realms, their ‘absence’ from home sets off alarm bells; overnight parental and local concern becomes international. The government declares days of ´national mourning´. Huge rewards are offered, tempting bounty hunters from across the globe.</p>
<p>In brief, their ‘disappearance’ is taken more seriously than any outbreak of COVID-19, or war in the Ukraine.</p>
<p>Conversational in style, the text both challenges and entertains while offering multiple perspectives. The element of surprise, the thirst for adventure, the search for knowledge and happiness sustain the reader’s interest throughout while driving the novel forward into sequels.</p>
<p>Their quest (what is it that we all really want from life?) is now yours. Follow them and see what happens.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?11490fd1